import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface SpellingLessonDetailsResponse {
  spelling_lesson_details: {
    created_at: number
    highest_score: number
    latest_score: number
    lesson_number: number
    attempts: number
    incorrect: Record<string, string>
    challenge: string[]
    focus_sound_words: string[]
    high_frequency_sight_words: string[]
  }[]
}

export type SpellingLessonDetailsData = SpellingLessonDetailsResponse['spelling_lesson_details']

export async function spellingLessonDetails(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<SpellingLessonDetailsData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('spelling_lesson_details', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<SpellingLessonDetailsResponse>(url, query)
  if (!data) return null

  const { spelling_lesson_details } = data
  if (spelling_lesson_details.length === 0) return null

  return spelling_lesson_details
}
